import React from 'react';
import TickGreen from '../../../../Assets/Modals/TickGreen.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setSelectedPost, updateSellerPosts } from '../../../../Features/lensSlice';
import { deletePost } from '../../../../lib/utils/apiCalls';
import { showToast } from '../../../../Components/Toaster/Toaster';

function DeletePost() {
    const dispatch = useDispatch();
    const selectedPost = useSelector((state) => state.lens.modal.selectedPost);

    const handleCancelButttonClick = () => {
        dispatch(closeModal());
        dispatch(setSelectedPost({}));
    }

    const handleDeleteButttonClick = async () => {
        let postId = selectedPost.id;

        try {
            const response = await deletePost(postId);
            if(response?.status === 200) {
                dispatch(updateSellerPosts(postId));
                handleCancelButttonClick();
                showToast('Lens post deleted!', 'success');
            }
            else {
                showToast('Error deleting post!', 'error');
            }
        }
        catch(err) {
            showToast('Error deleting post!', 'error');
        }
    }

    return (
        <div className="font-urbanist-regular w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Delete Post</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>Are you sure you want to delete this post?</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelButttonClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleDeleteButttonClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-[#DC2626] shadow-[0px_1px_2px_0px_#0000000D]'>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeletePost;
